import api from "./API";
import ApiEndpointConstants from "../constans/ApiEndpointConstants";

export const getpixel = (url) => {
  return api.post(`${ApiEndpointConstants.PIXEL}`, { url: url });
};
